module.exports = __webpack_public_path__ + "static/school-bus-tracking-app-5c9ce9baaff77bb3f1a8e43740b35310.jpg";